import { Box } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import useResponsive from 'commons/components/Responsive/useResponsive';
import { MESSAGES_ROUTES } from 'domains/Customers/Messages/messagesRoutes';
import {
  SectionAppCard,
  SectionAppCardDomains,
} from 'domains/PartnersApps/components';
import initialScreenImg from './initial-screen.svg';

export default function MessagesListInitialScreen(): JSX.Element {
  const { t } = useTranslation(Domain.CUSTOMERS);

  const { isMobile } = useResponsive();

  return (
    <Box mb={isMobile ? '2' : '8'}>
      <InitialScreen>
        <InitialScreen.Hero
          title={t('messages.emptyResults.title')}
          subtitle={t('messages.emptyResults.subtitle').toUpperCase()}
          description={t('messages.emptyResults.body')}
          image={
            <img src={initialScreenImg} width="100%" height="auto" alt="" />
          }
          actions={
            <InitialScreen.Module title="" description="">
              <SectionAppCard
                source={MESSAGES_ROUTES.messages}
                appCategory="communication"
                domain={SectionAppCardDomains.MESSAGES}
              />
            </InitialScreen.Module>
          }
        />
      </InitialScreen>
    </Box>
  );
}
